import React, { useState } from 'react';
import 'bootstrap/js/src/modal';
import DatePicker from 'react-date-picker';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { useMutation, useReactiveVar } from '@apollo/react-hooks';
import { toast } from 'react-toastify';
import { UPDATE_EXPERIENCE } from '../../graphql';
import Error from '../Error';
import { currentExperienceVar } from '../../graphql/config';
import hideModal from '../../styles/js/hideModal';

const EditExperienceModal = ({ refetch }) => {
  const {
    id,
    title,
    company,
    description,
    from: existingFrom,
    to: existingTo,
  } = useReactiveVar(currentExperienceVar);

  const [txtDescription, setTxtDescription] = useState();
  const [present, setPresent] = useState(false);

  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  existingFrom && !from && setFrom(new Date(existingFrom));
  existingTo && !to && setTo(new Date(existingTo));
  description && !txtDescription && setTxtDescription(description);

  const [updateExperience, { loading }] = useMutation(UPDATE_EXPERIENCE);
  const { register, handleSubmit, errors, reset } = useForm();

  const clearForm = () => {
    reset();
    setFrom(null);
    setTo(null);
    setTxtDescription(null);
  };

  const editExperience = (data) => {
    toast.dismiss();

    const input = {
      ...data,
    };

    if (from) {
      input.from = moment(from).format('YYYY-MM-DD');
    }

    if (!present) {
      input.to = moment(to).format('YYYY-MM-DD');
    }

    if (to === null) {
      input.to = null;
    }

    return updateExperience({
      variables: {
        id,
        input,
      },
    })
      .then(() => {
        currentExperienceVar({});
        clearForm();
        refetch();
        hideModal();
        toast.success('Experience updated successfully!', { autoClose: 4000 });
      })
      .catch((e) => {
        toast.error('Could not edit experience', { toastId: 'addExErr' });
      });
  };

  return (
    <div>
      <div
        className="modal fade"
        id="edit_experience_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="edit_experience_modal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <h3 className="txt__fw-600 text-center mb-60">Edit Experience</h3>
              <form className="row">
                <div className="col-12">
                  <div className="form__input-block mb-50">
                    <span className="txt__fw-600">Title</span>
                    <div className="form__input-wrapper">
                      <input
                        className="form__input"
                        type="text"
                        autoComplete="false"
                        name="title"
                        ref={register({ required: true })}
                        defaultValue={title}
                      />
                      <div className="form__clear form__hidden">
                        <i className="fas fa-times" />
                      </div>
                    </div>
                    {errors.title && (
                      <Error text="This field is required" noMargin />
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form__input-block mb-50">
                    <span className="txt__fw-600">Employer</span>
                    <div className="form__input-wrapper">
                      <input
                        className="form__input"
                        type="text"
                        autoComplete="false"
                        name="company"
                        ref={register({ required: true })}
                        defaultValue={company}
                      />
                      <div className="form__clear form__hidden">
                        <i className="fas fa-times" />
                      </div>
                    </div>
                    {errors.qualification && (
                      <Error text="This field is required" noMargin />
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <div className="form__input-block mb-50">
                    <span className="txt__fw-600">Start Date</span>
                    <div className="form__input-wrapper">
                      <DatePicker
                        onChange={setFrom}
                        value={from}
                        className="form__input date"
                        format="MM-y"
                        name="from"
                        required
                        maxDetail="year"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form__input-block mb-50">
                    <span className="txt__fw-600">End Date</span>
                    <input
                      type="checkbox"
                      style={{ marginLeft: '20px', marginRight: '10px' }}
                      onClick={() => setPresent(!present)}
                    />
                    Present
                    <div className="form__input-wrapper">
                      <DatePicker
                        onChange={setTo}
                        value={to}
                        className="form__input date"
                        format="MM-y"
                        name="to"
                        required={false}
                        maxDetail="year"
                        monthPlaceholder="mm"
                        disabled={present}
                        yearPlaceholder="yyyy"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <span className="txt__fw-600">Description</span>
                  <textarea
                    rows="8"
                    className="form__textarea height__unset"
                    placeholder="Add your description here..."
                    name="description"
                    ref={register({ required: true })}
                    defaultValue={description}
                  />
                  {errors.description && (
                    <Error text="This field is required" noMargin />
                  )}
                </div>
                <div className="col-12 text-center">
                  <a
                    href="/#"
                    className="form__btn btn-v2 d-block bg-freelancer"
                    onClick={handleSubmit(editExperience)}
                  >
                    {loading ? 'Loading...' : 'Save'}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditExperienceModal;
